import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import shot from '../Assets/cuirate-sheet.jpg';

const KEY = 'sitscom-cuirate-notice';
const HREF = 'https://cuirate.vercel.app';
const QUIET = ['/signin', '/admin', '/addData', '/paper', '/feedback'];

export default function CuirateNotice() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(KEY)) return;
    if (QUIET.some((path) => pathname.startsWith(path))) return;

    const timer = window.setTimeout(() => setOpen(true), 2200);
    return () => window.clearTimeout(timer);
  }, [pathname]);

  useEffect(() => {
    if (!open) return undefined;

    const onKey = (event) => {
      if (event.key === 'Escape') dismiss();
    };
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);

    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener('keydown', onKey);
    };
  }, [open]);

  const dismiss = () => {
    localStorage.setItem(KEY, '1');
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div className="cuirate-notice-overlay" onClick={dismiss}>
      <div
        className="cuirate-notice"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cuirate-notice-title"
        onClick={(event) => event.stopPropagation()}
      >
        <p className="cuirate-notice-stamp">On request (not by me)</p>
        <h3 id="cuirate-notice-title">Review CUI professors</h3>
        <p>
          You can use this site to review professors at CUI. Lahore, Islamabad,
          Abbottabad, and Vehari.
        </p>
        <a
          className="cuirate-notice-shot"
          href={HREF}
          target="_blank"
          rel="noreferrer"
          onClick={dismiss}
        >
          <img src={shot} alt="cuirate — 1,424 professors across 4 campuses" />
        </a>
        <div className="modal-actions">
          <button type="button" className="btn btn-ghost" onClick={dismiss}>
            No thanks
          </button>
          <a className="btn btn-primary" href={HREF} target="_blank" rel="noreferrer" onClick={dismiss}>
            Open cuirate
          </a>
        </div>
      </div>
    </div>
  );
}
